import React from 'react';

interface ModelViewerConfiguratorOverlayProps {
  iframeRef: React.RefObject<HTMLIFrameElement>;
  embedUrl: string;
  isReady: boolean;
}

function ModelViewerConfiguratorOverlay({
  iframeRef,
  embedUrl,
  isReady
}: ModelViewerConfiguratorOverlayProps) {
  return (
    <div className="absolute inset-0 z-50 bg-white dark:bg-gray-900">
      <iframe
        ref={iframeRef}
        src={embedUrl}
        className="w-full h-full border-0"
        title="3D Configurator"
      />
      {!isReady && (
        <div className="absolute inset-0 z-20 bg-white dark:bg-gray-900 flex items-center justify-center">
          <div className="animate-spin w-16 h-16 rounded-full border-4 border-gray-200 dark:border-gray-700 border-t-purple-600" />
        </div>
      )}
    </div>
  );
}

export default ModelViewerConfiguratorOverlay;
